import React from "react";
import { makeStyles } from "@material-ui/core";
import CardDownload from './cardDownload';

let useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        flexDirection: 'column',
        ...theme.grid.gridMdContent,
        width: "100%",
        maxWidth: '100%',

    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        right: '50%',
    },
    gridTitle: {
        position: 'relative',
        marginTop: 100,
    },
    title: {
        fontSize: 28,
        marginBottom: 75,
        '@media (max-width:445px)': {
            textAlign: 'center',
        },
    },
    gridDownload: {
        width: '35%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        flexWrap:'wrap',
        minWidth: 1150,
        '@media (max-width:1210px)': {
            minWidth: '95%',
            margin:'auto',
        },
        '@media (max-width:750px)': {
            textAlign: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            minWidth: '100%',
        },
    },
}))


export default function Index() {

    let classes = useStyles();

    let data = [
        {
            title: 'آموزش رایان همراه',
            link: '/assets/file/system/آموزش رایان همراه.pdf',
        },
        {
            title: 'راهنمای آنلاین اکسیر',
            link: '/assets/file/system/راهنمای آنلاین اکسیر.pdf',
        },
        {
            title: 'راهنمای آنلاین قدیمی',
            link: '/assets/file/system/راهنمای آنلاین قدیمی.pdf',
        },
        {
            title: 'راهنمای همراه پلاس',
            link: '/assets/file/system/rahnama-hamrah.pdf',
        },
        {
            title: 'راهنمای آنلاین پلاس',
            link: '/assets/file/system/rahnama-online.pdf',
        },
    ]

    return (
        <div className={classes['root']}>
            <div className={classes['gridTitle']}>
                <div className={classes['line']} />
                <h3 className={classes['title']}>
                    دانلود فایل های آموزشی
                </h3>
            </div>
            <div className={classes['gridDownload']}>
                {
                    data?.map((item, index) => {
                        return (
                            <CardDownload data={item} key={index} />
                        )
                    })
                }
            </div>
        </div>)
}

